import { Component, PropTypes, createElement } from 'react';
import { qualifyUrl, isQualifiedUrlNofollow } from '@seek/seek-jobs-seo';
import { withRouter, routerShape } from 'react-router';
import hoistNonReactStatic from 'hoist-non-react-statics';
import omit from 'lodash.omit';

export function getLinkLocation({ qualifiedUrl, state }) {
  const { path, query, isPlaceholder } = qualifiedUrl;
  const hash = isPlaceholder ? '#' : '';
  return { pathname: path, query, state, hash };
}

export function getQualifiedUrl(location, path, query) {
  const { locale, pathname: currentPath, query: currentQuery } = location;
  const isPlaceholder = !path;
  const currentUrl = { path: currentPath, query: currentQuery };
  const qualifiedUrl = isPlaceholder ? currentUrl : qualifyUrl(locale, path, query);
  const nofollow = isQualifiedUrlNofollow(qualifiedUrl);
  return {
    ...qualifiedUrl,
    isPlaceholder,
    nofollow
  };
}

export function provideQualifiedLinkParams(WrappedComponent) {
  class WithQualifiedLocation extends Component {
    static contextTypes = {
      store: PropTypes.shape({
        dispatch: PropTypes.func.isRequired,
        getState: PropTypes.func.isRequired
      }).isRequired
    }

    static propTypes = {
      router: routerShape.isRequired
    }

    constructor(props) {
      super(props);
      this.getQualifiedLinkParams = this.getQualifiedLinkParams.bind(this);
    }

    getQualifiedLinkParams(path, params, state) {
      const { store } = this.context;
      const { router } = this.props;
      const { location } = store.getState();
      const qualifiedUrl = getQualifiedUrl(location, path, params);
      const href = router.createHref(getLinkLocation({ qualifiedUrl, state }));
      const rel = qualifiedUrl.nofollow ? 'nofollow' : null;
      return { href, rel };
    }

    render() {
      const { dispatch } = this.context.store;
      const getQualifiedLinkParams = this.getQualifiedLinkParams;
      const mergedProps = {
        ...omit(this.props, 'router'),
        dispatch,
        getQualifiedLinkParams
      };
      return createElement(WrappedComponent, mergedProps);
    }
  }
  return hoistNonReactStatic(withRouter(WithQualifiedLocation), WrappedComponent);
}



/** WEBPACK FOOTER **
 ** ./app/wip_modules/qualified-location/index.js
 **/